import { ShareBaseDialog } from 'sharebase/domain/sharebase-dialog';
import { TaskAction } from 'sharebase/domain/task.actions';

require('./taskCommentDialog.styles');

const template = require('./taskCommentDialog.template');

export class TaskCommentDialog extends ShareBaseDialog {
	public static $inject = [
		'$mdDialog',
		'gettextCatalog'
	];

	constructor(
		$mdDialog:ng.material.IDialogService,
		private gettextCatalog:ng.gettext.gettextCatalog
	) {
		super($mdDialog, template, gettextCatalog.getString('Add comment'));
	}

	public comment:string;
	public label:string;

	public open(event:ng.IAngularEvent, action:TaskAction) {
		this.label = action === TaskAction.ApproveWithComment ? this.gettextCatalog.getString('Approve Task') : this.gettextCatalog.getString('Deny Task');

		return super.open(event)
			.then(res => this.comment)
			.finally(() => this.comment = null);
	}

	public retrieveComment() {
		super.dismiss(this.comment);
	}
}



// WEBPACK FOOTER //
// ./src/sharebase-app/components/taskCommentDialog/taskCommentDialog.ts